import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Microscope, ClipboardList, Crosshair, HeartPulse, ArrowRight } from "lucide-react";
const pillars = [{
  title: "Bespoke Consultation",
  description: "A deep dive into your skin's unique needs, combining expert analysis with your personal aesthetic goals.",
  icon: Microscope
}, {
  title: "Curated Rituals",
  description: "Designing a sanctuary-grade treatment plan that blends clinical aesthetics with restorative beauty rituals.",
  icon: ClipboardList
}, {
  title: "Artful Precision",
  description: "Executing every procedure with a master's touch, utilizing high-end formulations and advanced techniques.",
  icon: Crosshair
}, {
  title: "Luminous Results",
  description: "Maintaining your radiance with personalized home-care protocols and scheduled wellness check-ins.",
  icon: HeartPulse
}];
export default function OurPhilosophy() {
  return <section data-section-id="110774" id="the-natalia-standard" className="bg-background text-foreground relative overflow-hidden py-24 md:py-32">
      {}
      <div className="pointer-events-none absolute top-0 right-0 h-[600px] w-[600px] -translate-y-1/4 translate-x-1/4 rounded-lg bg-secondary/30 blur-[120px]" />
      <div className="pointer-events-none absolute bottom-0 left-0 h-[400px] w-[400px] translate-y-1/4 -translate-x-1/4 rounded-lg bg-primary/20 blur-[100px]" />

      <div className="container mx-auto px-6 md:px-12 lg:px-24 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-24 items-start">
          
          {}
          <div className="lg:col-span-5 lg:sticky lg:top-32">
            <h3 className="text-xs font-sans tracking-[0.2em] text-primary uppercase mb-12 flex items-center gap-4">
              <span className="h-px w-8 bg-primary/50 block"></span>
              The Natalia Standard
            </h3>
            
            <div className="relative pl-8 md:pl-10">
              {}
              <div className="absolute left-[11px] md:left-[15px] top-2 bottom-2 w-px bg-gradient-to-b from-primary via-primary/30 to-transparent" />
              
              <div className="space-y-12">
                {pillars.map((pillar, i) => {
                const Icon = pillar.icon;
                return <div key={i} data-index={i} className="relative group">
                      {}
                      <div className="absolute -left-8 md:-left-10 top-1 flex h-6 w-6 items-center justify-center rounded-lg bg-background border border-primary/40 shadow-sm group-hover:shadow-[0_0_15px_rgba(200,180,150,0.3)] transition-shadow duration-500">
                        <div className="h-2 w-2 rounded-lg bg-primary" />
                      </div>
                      
                      {}
                      <div className="bg-white/40 backdrop-blur-md border border-white/20 rounded-2xl p-6 transition-all hover:bg-white/60 hover:shadow-lg">
                        <div className="mb-4 inline-flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10 text-primary">
                          <Icon className="h-5 w-5" />
                        </div>
                        <h4 className="text-xl font-serif font-medium text-foreground mb-2 tracking-wide">
                          {pillar.title}
                        </h4>
                        <p className="text-muted-foreground font-sans leading-relaxed text-sm">
                          {pillar.description}
                        </p>
                      </div>
                    </div>;
              })}
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-7 flex flex-col justify-center">
            <div className="space-y-8">
              <h2 className="text-5xl md:text-6xl lg:text-7xl font-serif font-light tracking-tight text-foreground leading-[1.1]">
                Elevating the <br className="hidden md:block" />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary">
                  Aesthetic Experience.
                </span>
              </h2>
              
              <div className="h-px w-full bg-border/40 my-8" />

              <div className="space-y-6 text-lg md:text-xl text-muted-foreground leading-relaxed font-sans font-light">
                <p>
                  At Natalia’s Beauty, we believe that true elegance lies in the harmony between clinical precision and pure relaxation. Our Brooke sanctuary is designed to be more than a clinic—it is a destination for transformation.
                </p>
                <p>
                  We have evolved beyond the standard beauty salon, creating an environment that feels both sophisticated and deeply personal. From advanced aesthetics to therapeutic massage, every touch is intentional and every tool is selected for excellence.
                </p>
                <p>
                  This is high-end beauty curated for the modern individual. We respect your need for tranquility, prioritize your skin's health, and deliver results that enhance your natural radiance without compromise.
                </p>
              </div>

              <div className="pt-8 flex flex-col sm:flex-row gap-4">
                <Button asChild size="lg" className="h-14 px-8 text-sm uppercase tracking-widest rounded-lg bg-primary text-primary-foreground hover:bg-primary/90">
                  <Link to="https://nataliasbeauty.com/beauty-menu/">
                    Explore Our Rituals
                    <ArrowRight className="ml-2 h-5 w-5" />
                  </Link>
                </Button>
                <Button asChild variant="outline" size="lg" className="h-14 px-8 text-sm uppercase tracking-widest rounded-lg bg-transparent border-primary/20 hover:bg-secondary/20 hover:text-foreground">
                  <Link to="https://content-man.10web.cloud/the-clinic/">
                    The Brooke Sanctuary
                  </Link>
                </Button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}